<header class="fixed w-full z-30" *transloco="let t">
  <div class="container">
    <div
      class="header-bar relative flex items-center justify-between gap-2 sm:gap-3 h-14 sm:h-16 rounded-xl sm:rounded-2xl px-3 sm:px-4 backdrop-blur-[15px] bg-background/90 shadow-[0_4px_30px_0_rgba(80,104,147,0.12)]"
    >
      <div class="flex-1 flex items-center gap-2">
        <a
          routerLink="."
          class="inline-flex items-center gap-2"
          [attr.aria-label]="t('nav.platform')"
          hlmTooltip="{{ t('nav.goHome') }}"
          position="bottom"
        >
          <img
            src="/images/logo.webp"
            alt="GuestGenie Logo"
            class="h-7 sm:h-8 w-auto"
            width="163"
            height="30"
          />
        </a>
      </div>

      <nav
        hlmNavigationMenu
        class="hidden md:flex md:grow items-center justify-center flex-[80%]!"
      >
        <ul hlmNavigationMenuList class="gap-2">
          <!--  <li hlmNavigationMenuItem>
            <a hlmNavigationMenuLink routerLink="/" routerLinkActive="active">{{
              t('nav.home')
            }}</a>
          </li> -->
          <li
            hlmNavigationMenuItem
            [class.platform-active]="isPlatformActive()"
          >
            <button
              hlmNavigationMenuTrigger
              [class.platform-active]="isPlatformActive()"
              class="bg-transparent text-[15px] tracking-[0.03rem]"
            >
              {{ t('nav.platform') }}
              <ng-icon
                name="lucideChevronDown"
                class="relative top-px ml-1 size-3 transition duration-300 group-data-[state=open]:rotate-180"
              />
            </button>
            <hlm-navigation-menu-content
              *hlmNavigationMenuPortal
              class="p-0 shadow-2xl! rounded-xl! border border-gray-100! overflow-auto mt-6!"
            >
              <div
                class="grid w-[min(95vw,500px)] md:w-[600px] lg:w-[700px] grid-cols-1 sm:grid-cols-2 overflow-hidden rounded-xl p-0"
              >
                <div class="flex flex-col gap-2 bg-white p-6">
                  <span hlmPretitle class="text-gray-500 mb-1">{{
                    t('nav.solutions')
                  }}</span>
                  <ul class="flex flex-col">
                    <li>
                      <a
                        hlmNavigationMenuLink
                        routerLink="platform/overview"
                        routerLinkActive="active"
                        class="platform-nav-link flex-row py-2.5 px-0 hover:bg-transparent active:bg-transparent visited:bg-transparent hover:text-neutral-500"
                      >
                        <h5 hlmH5>{{ t('nav.overview') }}</h5>
                      </a>
                    </li>
                    <li>
                      <a
                        hlmNavigationMenuLink
                        routerLink="platform/smart-locks"
                        routerLinkActive="active"
                        class="platform-nav-link flex-row py-2.5 px-0 hover:bg-transparent active:bg-transparent visited:bg-transparent hover:text-neutral-500"
                      >
                        <h5 hlmH5>{{ t('nav.smartLocks') }}</h5>
                      </a>
                    </li>
                    <li>
                      <a
                        hlmNavigationMenuLink
                        routerLink="platform/property-intelligence"
                        routerLinkActive="active"
                        class="platform-nav-link flex-row py-2.5 px-0 hover:bg-transparent active:bg-transparent visited:bg-transparent hover:text-neutral-600"
                      >
                        <h5 hlmH5>{{ t('nav.propertyIntelligence') }}</h5>
                      </a>
                    </li>
                    <li>
                      <a
                        hlmNavigationMenuLink
                        routerLink="platform/ai-messaging-concierge"
                        routerLinkActive="active"
                        class="platform-nav-link flex-row py-2.5 px-0 hover:bg-transparent active:bg-transparent visited:bg-transparent hover:text-neutral-500"
                      >
                        <h5 hlmH5>{{ t('nav.aiMessagingConcierge') }}</h5>
                      </a>
                    </li>
                  </ul>
                </div>

                <div class="flex flex-col gap-4 bg-silver-50/60 p-6">
                  <span hlmPretitle class="text-primary-600/60">{{
                    t('nav.otherProducts')
                  }}</span>
                  <a
                    hlmNavigationMenuLink
                    routerLink="platform/for-guests"
                    routerLinkActive="active"
                    class="others-products-nav-link flex flex-1 min-h-0 flex-row items-center gap-5 rounded-lg hover:bg-primary-600/10 active:bg-primary-600/10 focus:bg-primary-600/10 focus-visible:bg-primary-600/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 p-2 -mx-2"
                  >
                    <span
                      class="flex size-13 shrink-0 items-center justify-center rounded-full bg-primary-300 text-black"
                    >
                      <ng-icon hlm name="lucideBriefcase" class="text-black" />
                    </span>
                    <div class="flex flex-col gap-0.5 text-left min-w-0">
                      <h5 hlmH5>{{ t('nav.forGuests') }}</h5>
                      <p hlmSmall class="text-gray-500">
                        {{ t('nav.forGuestsDesc') }}
                      </p>
                    </div>
                  </a>
                  <a
                    hlmNavigationMenuLink
                    routerLink="platform/for-service-providers"
                    routerLinkActive="active"
                    class="others-products-nav-link flex flex-1 min-h-0 flex-row items-center gap-5 rounded-lg hover:bg-primary-600/10 active:bg-primary-600/10 focus:bg-primary-600/10 focus-visible:bg-primary-600/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 p-2 -mx-2"
                  >
                    <span
                      class="flex size-13 shrink-0 items-center justify-center rounded-full bg-primary-300"
                    >
                      <ng-icon hlm name="lucideWrench" class="text-black" />
                    </span>
                    <div class="flex flex-col gap-0.5 text-left min-w-0">
                      <h5 hlmH5>{{ t('nav.forServiceProviders') }}</h5>
                      <p hlmSmall class="text-gray-500">
                        {{ t('nav.forServiceProvidersDesc') }}
                      </p>
                    </div>
                  </a>
                </div>
              </div>
            </hlm-navigation-menu-content>
          </li>

          <li hlmNavigationMenuItem>
            <a
              hlmNavigationMenuLink
              routerLink="pricing"
              routerLinkActive="active"
              class="text-[15px] tracking-[0.03rem]"
              >{{ t('nav.pricing') }}</a
            >
          </li>

          <li hlmNavigationMenuItem>
            <a
              hlmNavigationMenuLink
              routerLink="about-us"
              routerLinkActive="active"
              class="text-[15px] tracking-[0.03rem]"
              >{{ t('nav.aboutUs') }}</a
            >
          </li>

          <li hlmNavigationMenuItem>
            <a
              hlmNavigationMenuLink
              routerLink="become-a-partner"
              routerLinkActive="active"
              class="text-[15px] tracking-[0.03rem]"
              >{{ t('nav.becomeAPartner') }}</a
            >
          </li>
        </ul>
      </nav>

      <ul class="flex-1 flex justify-end items-center gap-3">
        <li class="hidden md:block">
          <button hlmBtn variant="ghost" routerLink="sign-in" size="lg">
            {{ t('nav.signIn') }}
          </button>
        </li>
        <li class="hidden md:block">
          <button
            hlmBtn
            size="lg"
            variant="secondary"
            data-cal-link="juan-manuel-ortiz-gz54cr/30min"
            data-cal-namespace="30min"
            data-cal-config='{"layout":"month_view","useSlotsViewOnSmallScreen":"true","theme":"light"}'
          >
            {{ t('nav.bookADemo') }}
          </button>
        </li>
      </ul>

      <div class="flex md:hidden">
        <button
          type="button"
          class="mobile-menu-btn inline-flex w-8 h-8 text-foreground bg-background items-center justify-center rounded-md transition"
          [class.mobile-menu-open]="mobileOpen"
          [attr.aria-expanded]="mobileOpen"
          [attr.aria-controls]="'mobile-nav'"
          (click)="toggleMobile()"
        >
          <span class="sr-only">{{ t('nav.menu') }}</span>
          <svg
            class="w-4 h-4 fill-current pointer-events-none"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              class="mobile-bar mobile-bar-top"
              y="7"
              width="9"
              height="2"
              rx="1"
            />
            <rect
              class="mobile-bar mobile-bar-mid"
              y="7"
              width="16"
              height="2"
              rx="1"
            />
            <rect
              class="mobile-bar mobile-bar-bot"
              y="7"
              width="9"
              height="2"
              rx="1"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>

  @if (mobileOpen) {
    <div
      id="mobile-nav"
      class="md:hidden fixed inset-0 z-20 bg-background mobile-menu-panel overflow-y-auto"
    >
      <div class="flex flex-col min-h-full pt-20 sm:pt-24">
        <button
          type="button"
          class="absolute top-6 right-6 sm:top-7 sm:right-8 flex items-center justify-center size-10 rounded-full bg-silver-100 text-foreground transition-colors hover:bg-silver-200"
          aria-label="Close menu"
          (click)="closeMobile()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <!-- Navigation links -->
        <nav class="flex-1 flex flex-col px-6 sm:px-8 pt-4 pb-6">
          <a
            routerLink="platform/overview"
            routerLinkActive="mobile-link-active"
            (click)="closeMobile()"
            class="mobile-nav-link"
            >{{ t('nav.overview') }}</a
          >
          <a
            routerLink="platform/smart-locks"
            routerLinkActive="mobile-link-active"
            (click)="closeMobile()"
            class="mobile-nav-link"
            >{{ t('nav.smartLocks') }}</a
          >
          <a
            routerLink="platform/property-intelligence"
            routerLinkActive="mobile-link-active"
            (click)="closeMobile()"
            class="mobile-nav-link"
            >{{ t('nav.propertyIntelligence') }}</a
          >
          <a
            routerLink="platform/ai-messaging-concierge"
            routerLinkActive="mobile-link-active"
            (click)="closeMobile()"
            class="mobile-nav-link"
            >{{ t('nav.aiMessagingConcierge') }}</a
          >
          <div class="divider h-px w-full bg-primary-300 my-2"></div>
          <a
            routerLink="platform/for-guests"
            routerLinkActive="mobile-link-active"
            (click)="closeMobile()"
            class="mobile-nav-link"
            >{{ t('nav.forGuests') }}</a
          >
          <a
            routerLink="platform/for-service-providers"
            routerLinkActive="mobile-link-active"
            (click)="closeMobile()"
            class="mobile-nav-link"
            >{{ t('nav.forServiceProviders') }}</a
          >
          <div class="divider h-px w-full bg-primary-300 my-2"></div>
          <a
            routerLink="pricing"
            routerLinkActive="mobile-link-active"
            (click)="closeMobile()"
            class="mobile-nav-link"
            >{{ t('nav.pricing') }}</a
          >
          <a
            routerLink="about-us"
            routerLinkActive="mobile-link-active"
            (click)="closeMobile()"
            class="mobile-nav-link"
            >{{ t('nav.aboutUs') }}</a
          >
          <a
            routerLink="become-a-partner"
            routerLinkActive="mobile-link-active"
            (click)="closeMobile()"
            class="mobile-nav-link"
            >{{ t('nav.becomeAPartner') }}</a
          >
        </nav>

        <!-- Bottom section -->
        <div
          class="px-6 sm:px-8 pb-8 pt-6 border-t border-border flex flex-col gap-5"
        >
          <div>
            <span
              class="text-muted-foreground text-xs font-mono font-medium uppercase tracking-widest"
            >
              {{ t('footer.getInTouch') }}
            </span>
            <a
              href="mailto:support@guestgenie.com"
              class="text-foreground font-semibold text-sm block mt-1.5 hover:underline"
            >
              support&#64;guestgenie.com
            </a>
          </div>

          <div class="flex gap-3">
            <a
              href="https://www.linkedin.com/company/guestgenie/"
              target="_blank"
              rel="noopener noreferrer"
              class="flex items-center justify-center size-10 rounded-full bg-silver-100 text-foreground transition-colors hover:bg-silver-200"
              aria-label="LinkedIn"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/guestgenieapp"
              target="_blank"
              rel="noopener noreferrer"
              class="flex items-center justify-center size-10 rounded-full bg-silver-100 text-foreground transition-colors hover:bg-silver-200"
              aria-label="Instagram"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
                <circle cx="12" cy="12" r="5" />
                <circle
                  cx="17.5"
                  cy="6.5"
                  r="1.5"
                  fill="currentColor"
                  stroke="none"
                />
              </svg>
            </a>
          </div>

          <button
            hlmBtn
            variant="default"
            size="lg"
            class="w-full"
            routerLink="book-a-demo"
            (click)="closeMobile()"
          >
            {{ t('nav.bookADemo') }}
          </button>
        </div>
      </div>
    </div>
  }
</header>
